import React, { Component } from 'react'
import EntityList from './../components/entityList';
import TrailerIcon from 'material-ui/svg-icons/places/rv-hookup';
import { hashHistory } from 'react-router'

const Styles = {
  optionsButton: {
    width: 32
  }
};

class InventoryReport extends Component {
  constructor(props, context) {
    super(props, context);

    this.showTrailers = this.showTrailers.bind(this);
  }

  showTrailers(entity) {
    if (entity.MakeID >0) {
      hashHistory.push('/inventorybymakereport/' + entity.MakeID);
    }
  }

  render() {
    return (
      <EntityList apiRoute='api/reports/inventory' title='Inventaire' allowEdit={false} allowAdd={false} allowDelete={false} displayColumns={[
        {Description: 'Marque', Column: 'Make'},
        {Description: 'Quantité', Column: 'Quantity'},
        {Description: 'Coûtant', Column: 'Cost', format: {type: 'money'}},
        {Description: 'Transport', Column: 'TransportCost', format: {type: 'money'}},
        {Description: 'Taux de change', Column: 'ExchangeRate', format: {type: 'money'}},
        {Description: 'Total coûtant', Column: 'TotalAllIncluded', format: {type: 'money'}},
        {Description: 'Total vendant', Column: 'TotalSelling', format: {type: 'money'}},
        {Description: '', sortable: false, dataAlias: '', style: Styles.optionsButton, format: {type: 'button', action: this.showTrailers, content: <TrailerIcon/> }}
      ]}/>
    )
  }
}

export default InventoryReport;


/** WEBPACK FOOTER **
 ** ./src/app/reports/inventory.js
 **/